import visualacuity from '../assets/img/visualacuity.png';

export const logmarLetterPool = { sloan: { allChars: 'COHZVSNDKR', numToDisplay: 5 }, glasgow: { allChars: 'VHYUXO', numToDisplay: 4 } };

export const logmarData = [
  {
    id: 1,
    value: 1,
  },
  {
    id: 2,
    value: 0.9,
  },
  {
    id: 3,
    value: 0.8,
  },
  {
    id: 4,
    value: 0.7,
  },
  {
    id: 5,
    value: 0.6,
  },
  {
    id: 6,
    value: 0.5,
  },
  {
    id: 7,
    value: 0.4,
  },
  {
    id: 8,
    value: 0.3,
  },
  {
    id: 9,
    value: 0.2,
  },
  {
    id: 10,
    value: 0.1,
  },
  {
    id: 11,
    value: 0.0,
  },
  {
    id: 12,
    value: -0.1,
  },
  {
    id: 13,
    value: -0.2,
  },
];

export const optimaChartData = [
  {
    id: 1,
    value: 'n104 — n72',
    navigation: {
      next: 'n56',
    },
    fontSizes: [
      {
        key: 'n104',
        value: '104pt',
        content: 'My girl',
        magnification: '+52d (14x)',
      },
      {
        key: 'n90',
        value: '90pt',
        content: 'wove six',
        magnification: '+40d (11x)',
      },
      {
        key: 'n72',
        value: '72pt',
        content: 'dozen plaid jackets',
        magnification: '+36d (10x)',
      },
    ],
  },
  {
    id: 2,
    value: 'n56 — n35',
    navigation: {
      next: 'n24',
      previous: 'n104',
    },
    fontSizes: [
      {
        key: 'n56',
        value: '56pt',
        content: 'before she quit',
        magnification: '+28d (8x)',
      },
      {
        key: 'n45',
        value: '45pt',
        content: 'Brown jars prevented the mixture from freezing too quickly',
        magnification: '+20d (6x)',
      },
      {
        key: 'n35',
        value: '35pt',
        content: 'Farmer Jack realised that big yellow quilts were expensive',
        magnification: '+16d (5x)',
      },
    ],
  },
  {
    id: 3,
    value: 'n24 — n16',
    navigation: {
      next: 'n12',
      previous: 'n56',
    },
    fontSizes: [
      {
        key: 'n24',
        value: '24pt',
        content: 'Pack my box with five dozen liquor jugs',
        magnification: '+12d (4x)',
      },
      {
        key: 'n20',
        value: '20pt',
        content: 'Pangrams have been used for years to teach handwriting and typing.',
        magnification: '+10d (3.5x)',
      },
      {
        key: 'n16',
        value: '16pt',
        content:
          'and to test typewriters, telegraphs, printers, typefaces and software. Graphic and font designers use pangrams to illustrate their work',
        magnification: '+8d (3x)',
      },
    ],
  },
  {
    id: 4,
    value: 'n12 — n8',
    navigation: {
      next: 'n6',
      previous: 'n24',
    },
    fontSizes: [
      {
        key: 'n12',
        value: '12pt',
        content:
          'For many pangram enthusiasts, the best pangrams are those with the fewest letters. “Mr. Jock, TV quiz Ph.D., bags few lynx.” is considered a “perfect pangram” because it contains only 26 letters.',
        magnification: '+6d (2.5x)',
      },
      {
        key: 'n10',
        value: '10pt',
        content:
          'Pangrams are also used to practice sending morse code.  Radio operators up until a few years ago had lists of pangrams that they would send to warm up.  They also sent short phrases with a nice rhythm, like “ben’s best bent wire”',
        magnification: '+5d (2.25x)',
      },
      {
        key: 'n8',
        value: '8pt',
        content:
          'If you can read this then you should manage to read standard news print.  This font is eight point Times New Roman.  It is used on a reading chart like this one to gauge whether you need reading glasses.  If you are wearing glasses then your corrected vision is adequate for newspapers.  If you are reading this with your naked eye then you probably do not need reading glasses.',
        magnification: 'Normal newspaper print',
      },
    ],
  },
  {
    id: 5,
    value: 'n6 — n4',
    navigation: {
      previous: 'n12',
    },
    fontSizes: [
      {
        key: 'n6',
        value: '6pt',
        content:
          'This is six point font.  It is very hard to read without the right glasses and good light.  It is used for things like very small print on labels.  It is sometimes used to hide clauses or ingredients that unscrupulous people do not want you to see.  If you find something written in six point font then get a magnifying glass and try to read it.  It might be important.',
        magnification: 'No correction necessary',
      },
      {
        key: 'n5',
        value: '5pt',
        content:
          'If you can read this then well done.  This is about the smallest font you will ever have to read.  It is five point Times New Roman.  It has been included on this chart to fill a couple of lines and to give people with exceptional near vision a chance to show off how small a font size they can manage.  ',
        magnification: 'No correction necessary',
      },
      {
        key: 'n4',
        value: '4pt',
        content:
          'If you are reading this line then you may be the first person in this practice to manage it.  Ask your optometrist how many people have reached this point on the chart with or without glasses.  You are one of a small minority.  ',
        magnification: 'No correction necessary',
      },
    ],
  },
];

export const tests = [
  {
    title: 'Visual Acuity',
    image: visualacuity,
    options: [
      { key: 'crowdedLogmar', value: 'Crowded Logmar' },
      { key: 'openLogmar', value: 'Open Logmar' },
      { key: 'randomE', value: 'Random E' },
      { key: 'optimaChart', value: 'Optima Chart' },
      { key: 'contrastSensitivity', value: 'Contrast Sensitivity' },
    ],
  },
];

export const testsMap = {
  crowdedLogmar: {
    title: 'Crowded Logmar',
    reactComponent: 'Logmar',
    logmarType: 'Crowded Logmar',
  },
  openLogmar: {
    title: 'Open Logmar',
    reactComponent: 'Logmar',
    logmarType: 'Open Logmar',
  },
  randomE: {
    reactComponent: 'RandomE',
  },
  optimaChart: {
    reactComponent: 'ICNVision',
  },
  contrastSensitivity: {
    reactComponent: 'ContrastSensitivity',
  },
  visualFieldTest: {
    reactComponent: 'VisualField',
  },
  visualFieldTwo: {
    reactComponent: 'VisualField',
  },
  visualFieldForthValley: {
    reactComponent: 'NeuroSuite',
  },
  Refraction: {
    reactComponent: 'Refraction',
  },
  RefractionTwo: {
    reactComponent: 'Refraction',
  },
  kaysOptotypes: {
    reactComponent: 'KaysOptotypes',
  },
  kaysMultiple: {
    reactComponent: 'KaysOptotypes',
  },
  // Colour Vision / Ishihara run live by the clinician (same result_data as the async pre-screening test).
  ishihara: {
    reactComponent: 'ColourVision',
  },
};

export const responsiveTestsMap = {
  crowdedLogmar: {
    title: 'Crowded Logmar',
    reactComponent: 'ResponsiveLogmarContainer',
    logmarType: 'Crowded Logmar',
  },
  openLogmar: {
    title: 'Open Logmar',
    reactComponent: 'ResponsiveLogmarContainer',
    logmarType: 'Open Logmar',
  },
  randomE: {
    reactComponent: 'ResponsiveRandomEContainer',
  },
  optimaChart: {
    reactComponent: 'ResponsiveOptimaChartContainer',
  },
  contrastSensitivity: {
    reactComponent: 'ResponsiveContrastSensitivityContainer',
  },
  Refraction: {
    reactComponent: 'ResponsiveRefractionContainer',
  },
  RefractionTwo: {
    reactComponent: 'ResponsiveRefractionTwoContainer',
  },
  kaysOptotypes: {
    reactComponent: 'ResponsiveKaysOptotypesContainer',
  },
  kaysMultiple: {
    reactComponent: 'MultipleContainer',
  },
};

export const logmarToSnellen = {
  '1.0': '6/60',
  0.9: '6/48',
  0.8: '6/38',
  0.7: '6/30',
  0.6: '6/24',
  0.5: '6/19',
  0.4: '6/15',
  0.3: '6/12',
  0.2: '6/9',
  0.1: '6/7.5',
  '0.0': '6/6',
  '-0.1': '6/5',
  '-0.2': '6/4',
};

export const logmarToAmericanSnellen = {
  '1.0': '20/200',
  0.9: '20/160',
  0.8: '20/125',
  0.7: '20/100',
  0.6: '20/80',
  0.5: '20/63',
  0.4: '20/50',
  0.3: '20/40',
  0.2: '20/32',
  0.1: '20/25',
  '0.0': '20/20',
  '-0.1': '20/16',
  '-0.2': '20/12.5',
};

export const logmarToMetric = {
  '1.0': '0.10',
  0.9: '0.13',
  0.8: '0.16',
  0.7: '0.20',
  0.6: '0.25',
  0.5: '0.32',
  0.4: '0.40',
  0.3: '0.50',
  0.2: '0.63',
  0.1: '0.80',
  '0.0': '1.00',
  '-0.1': '1.25',
  '-0.2': '1.60',
};

export const visualFieldSetup = {
  contrast: {
    id: 'contrast',
    name: 'Contrast',
    options: [
      // {
      //   id: 'contrast1',
      //   value: 'calibrated suprathreshold',
      //   label: 'Calibrated suprathreshold',
      // },
      {
        id: 'contrast2',
        value: 'maximum contrast',
        label: 'Maximum Contrast',
      },
    ],
  },
  targetSize: {
    id: 'targetSize',
    name: 'Target size',
    options: [
      {
        id: 'targetSize1',
        value: 'goldman 1',
        label: 'Goldman 1',
      },
      {
        id: 'targetSize2',
        value: 'goldman 2',
        label: 'Goldman 2',
      },
      {
        id: 'targetSize3',
        value: 'goldman 3',
        label: 'Goldman 3',
      },
      {
        id: 'targetSize4',
        value: 'goldman 4',
        label: 'Goldman 4',
      },
      {
        id: 'targetSize5',
        value: 'goldman 5',
        label: 'Goldman 5',
      },
    ],
  },
  targetDuration: {
    id: 'targetDuration',
    name: 'Target Duration',
    options: [
      {
        id: 'targetDuration1',
        value: 200,
        label: '0.2s',
      },
      {
        id: 'targetDuration2',
        value: 500,
        label: '0.5s',
      },
      {
        id: 'targetDuration3',
        value: 1000,
        label: '1.0s',
      },
      {
        id: 'targetDuration4',
        value: 3000,
        label: '3.0s',
      },
      {
        id: 'targetDuration5',
        value: 5000,
        label: '5.0s',
      },
      // {
      //   id: 'targetDuration6',
      //   value: 'manual',
      //   label: 'Manual',
      // },
    ],
  },
  fixationType: {
    id: 'fixationType',
    name: 'Fixation Type',
    options: [
      {
        id: 'thumbnailOperator',
        value: {
          width: 150,
          height: 100,
          type: 'thumbnailOperator',
          label: 'Thumbnail Operator',
        },
        label: 'Thumbnail Operator',
      },
      {
        id: 'rotatingWheel',
        value: {
          width: 50,
          height: 50,
          type: 'rotatingWheel',
          label: 'Rotating Wheel',
        },
        label: 'Rotating Wheel',
      },
      // {
      //   id: 'fixationType3',
      //   value: 'rotating wheel',
      //   label: 'Rotating wheel',
      // },
    ],
  },
  responseType: {
    id: 'responseType',
    name: 'Response Type',
    options: [
      // {
      //   id: 'responseType1',
      //   value: 'cursor',
      //   label: 'Cursor',
      // },
      // {
      //   id: 'responseType2',
      //   value: 'patient key click',
      //   label: 'Patient key click',
      // },
      {
        id: 'responseType3',
        value: 'patient mouse click',
        label: 'Patient Mouse Click',
      },
      // {
      //   id: 'responseType4',
      //   value: 'operator input',
      //   label: 'Operator input',
      // },
    ],
  },
  contrastType: {
    id: 'contrastType',
    name: 'Contrast Type',
    options: [
      // {
      //   id: 'responseType1',
      //   value: 'cursor',
      //   label: 'Cursor',
      // },
      // {
      //   id: 'responseType2',
      //   value: 'patient key click',
      //   label: 'Patient key click',
      // },
      {
        id: 'blackBackgroundWhiteStimulus',
        value: 'whiteOnBlack',
        label: 'White point on black background',
      },
      {
        id: 'whiteBackgroundBlackStimulus',
        value: 'blackOnWhite',
        label: 'Black point on white background',
      },
      // {
      //   id: 'responseType4',
      //   value: 'operator input',
      //   label: 'Operator input',
      // },
    ],
  },
};

export const eyeOptions = [
  { label: 'Left Eye', value: 'left' },
  { label: 'Right Eye', value: 'right' },
  { label: 'Binocular', value: 'bothEyes' },
  { label: 'Right Eye then Left Eye', value: 'leftAndRight' },
];

export const correctedOptions = [
  { label: 'Corrected', value: 'corrected' },
  { label: 'Uncorrected', value: 'uncorrected' },
];

export const letterOptions = [
  { label: 'Sloan', value: 'sloan' },
  { label: 'Glasgow Acuity Letters', value: 'glasgow' },
];

export const ibisVisionResultsMatrix = {
  0: [
    [{ color: 'white' }, { color: 'white' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'white' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
  ],
  1: [
    [{ color: 'grey' }, { color: 'grey' }, { color: 'white' }, { color: 'white' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'white' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
  ],
  2: [
    [{ color: 'white' }, { color: 'grey', blindspot: true }, { color: 'white' }, { color: 'white' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'white' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'white' }, { color: 'white' }, { color: 'grey' }, { color: 'grey' }],
  ],
  3: [
    [{ color: 'white' }, { color: 'white' }, { color: 'grey', blindspot: true }, { color: 'white' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'grey' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'grey' }, { color: 'white' }],
    [{ color: 'grey' }, { color: 'grey' }, { color: 'white' }, { color: 'white' }],
  ],
};

const controlRepeatTimes = 5;

export const forthValleyVisualFieldDots = [
  { degreeX: 25, degreeY: 0 },
  { degreeX: 6, degreeY: -6 },
  { degreeX: 15, degreeY: -15 },
  { degreeX: 25, degreeY: -25 },
  { degreeX: 0, degreeY: -25 },
  { degreeX: 0, degreeY: -15 },
  { degreeX: -6, degreeY: -6 },
  { degreeX: -15, degreeY: -15 },
  { degreeX: -25, degreeY: -25 },
  { degreeX: -15, degreeY: 0 },
  { degreeX: -25, degreeY: 0 },
  { degreeX: -6, degreeY: 6 },
  { degreeX: -15, degreeY: 15 },
  { degreeX: -25, degreeY: 25 },
  { degreeX: 0, degreeY: 25 },
  { degreeX: 0, degreeY: 15 },
  { degreeX: 6, degreeY: 6 },
  { degreeX: 15, degreeY: 15 },
  { degreeX: 25, degreeY: 25 },
  { degreeX: 15, degreeY: 0 },
];

export const visualFieldTwoDots = [
  { degreeX: -9, degreeY: 21 },
  { degreeX: -3, degreeY: 21 },
  { degreeX: -15, degreeY: 15 },
  { degreeX: -9, degreeY: 15 },
  { degreeX: -3, degreeY: 15 },
  { degreeX: -21, degreeY: 9 },
  { degreeX: -15, degreeY: 9 },
  { degreeX: -9, degreeY: 9 },
  { degreeX: -3, degreeY: 9 },
  { degreeX: -21, degreeY: 3 },
  { degreeX: -15, degreeY: 3 },
  { degreeX: -9, degreeY: 3 },
  { degreeX: -3, degreeY: 3 },
  { degreeX: 3, degreeY: 21 },
  { degreeX: 9, degreeY: 21 },
  { degreeX: 3, degreeY: 15 },
  { degreeX: 9, degreeY: 15 },
  { degreeX: 15, degreeY: 15 },
  { degreeX: 3, degreeY: 9 },
  { degreeX: 9, degreeY: 9 },
  { degreeX: 15, degreeY: 9 },
  { degreeX: 21, degreeY: 9 },
  { degreeX: 3, degreeY: 3 },
  { degreeX: 9, degreeY: 3 },
  { degreeX: 15, degreeY: 3 },
  { degreeX: 21, degreeY: 3 },
  { degreeX: -21, degreeY: -3 },
  { degreeX: -15, degreeY: -3 },
  { degreeX: -9, degreeY: -3 },
  { degreeX: -3, degreeY: -3 },
  { degreeX: -21, degreeY: -9 },
  { degreeX: -15, degreeY: -9 },
  { degreeX: -9, degreeY: -9 },
  { degreeX: -3, degreeY: -9 },
  { degreeX: -15, degreeY: -15 },
  { degreeX: -9, degreeY: -15 },
  { degreeX: -3, degreeY: -15 },
  { degreeX: -9, degreeY: -21 },
  { degreeX: -3, degreeY: -21 },
  { degreeX: 3, degreeY: -3 },
  { degreeX: 9, degreeY: -3 },
  { degreeX: 15, degreeY: -3 },
  { degreeX: 21, degreeY: -3 },
  { degreeX: 3, degreeY: -9 },
  { degreeX: 9, degreeY: -9 },
  { degreeX: 15, degreeY: -9 },
  { degreeX: 21, degreeY: -9 },
  { degreeX: 3, degreeY: -15 },
  { degreeX: 9, degreeY: -15 },
  { degreeX: 15, degreeY: -15 },
  { degreeX: 3, degreeY: -21 },
  { degreeX: 9, degreeY: -21 },
  { degreeX: -15, degreeY: -1.5, blindspot: true },
  { degreeX: 15, degreeY: -1.5, blindspot: true },
];

export const ibisvisionVisualFieldDots = {
  0: [
    { degreeX: 9, degreeY: 21, orientation: 'topLeft', resultCoordinate: { x: 0, y: 2 } },
    { degreeX: 3, degreeY: 21, orientation: 'topLeft', resultCoordinate: { x: 0, y: 3 } },
    { degreeX: 15, degreeY: 15, orientation: 'topLeft', resultCoordinate: { x: 1, y: 1 } },
    { degreeX: 9, degreeY: 15, orientation: 'topLeft', resultCoordinate: { x: 1, y: 2 } },
    { degreeX: 3, degreeY: 15, orientation: 'topLeft', resultCoordinate: { x: 1, y: 3 } },
    { degreeX: 21, degreeY: 9, orientation: 'topLeft', resultCoordinate: { x: 2, y: 0 } },
    { degreeX: 15, degreeY: 9, orientation: 'topLeft', resultCoordinate: { x: 2, y: 1 } },
    { degreeX: 9, degreeY: 9, orientation: 'topLeft', resultCoordinate: { x: 2, y: 2 } },
    { degreeX: 3, degreeY: 9, orientation: 'topLeft', resultCoordinate: { x: 2, y: 3 } },
    { degreeX: 21, degreeY: 3, orientation: 'topLeft', resultCoordinate: { x: 3, y: 0 } },
    { degreeX: 15, degreeY: 3, orientation: 'topLeft', resultCoordinate: { x: 3, y: 1 } },
    { degreeX: 9, degreeY: 3, orientation: 'topLeft', resultCoordinate: { x: 3, y: 2 } },
    { degreeX: 3, degreeY: 3, orientation: 'topLeft', resultCoordinate: { x: 3, y: 3 } },
  ],
  1: [
    { degreeX: 3, degreeY: 21, orientation: 'topRight', resultCoordinate: { x: 0, y: 0 } },
    { degreeX: 9, degreeY: 21, orientation: 'topRight', resultCoordinate: { x: 0, y: 1 } },
    { degreeX: 3, degreeY: 15, orientation: 'topRight', resultCoordinate: { x: 1, y: 0 } },
    { degreeX: 9, degreeY: 15, orientation: 'topRight', resultCoordinate: { x: 1, y: 1 } },
    { degreeX: 15, degreeY: 15, orientation: 'topRight', resultCoordinate: { x: 1, y: 2 } },
    { degreeX: 3, degreeY: 9, orientation: 'topRight', resultCoordinate: { x: 2, y: 0 } },
    { degreeX: 9, degreeY: 9, orientation: 'topRight', resultCoordinate: { x: 2, y: 1 } },
    { degreeX: 15, degreeY: 9, orientation: 'topRight', resultCoordinate: { x: 2, y: 2 } },
    { degreeX: 21, degreeY: 9, orientation: 'topRight', resultCoordinate: { x: 2, y: 3 } },
    { degreeX: 3, degreeY: 3, orientation: 'topRight', resultCoordinate: { x: 3, y: 0 } },
    { degreeX: 9, degreeY: 3, orientation: 'topRight', resultCoordinate: { x: 3, y: 1 } },
    { degreeX: 15, degreeY: 3, orientation: 'topRight', resultCoordinate: { x: 3, y: 2 } },
    { degreeX: 21, degreeY: 3, orientation: 'topRight', resultCoordinate: { x: 3, y: 3 } },
  ],
  2: [
    { degreeX: 15, degreeY: 1.5, orientation: 'bottomLeft', resultCoordinate: { x: 0, y: 1 }, blindspot: true, repeat: controlRepeatTimes },
    { degreeX: 21, degreeY: 3, orientation: 'bottomLeft', resultCoordinate: { x: 1, y: 0 } },
    { degreeX: 15, degreeY: 3, orientation: 'bottomLeft', resultCoordinate: { x: 1, y: 1 } },
    { degreeX: 9, degreeY: 3, orientation: 'bottomLeft', resultCoordinate: { x: 1, y: 2 } },
    { degreeX: 3, degreeY: 3, orientation: 'bottomLeft', resultCoordinate: { x: 1, y: 3 } },
    { degreeX: 21, degreeY: 9, orientation: 'bottomLeft', resultCoordinate: { x: 2, y: 0 } },
    { degreeX: 15, degreeY: 9, orientation: 'bottomLeft', resultCoordinate: { x: 2, y: 1 } },
    { degreeX: 9, degreeY: 9, orientation: 'bottomLeft', resultCoordinate: { x: 2, y: 2 } },
    { degreeX: 3, degreeY: 9, orientation: 'bottomLeft', resultCoordinate: { x: 2, y: 3 } },
    { degreeX: 15, degreeY: 15, orientation: 'bottomLeft', resultCoordinate: { x: 3, y: 1 } },
    { degreeX: 9, degreeY: 15, orientation: 'bottomLeft', resultCoordinate: { x: 3, y: 2 } },
    { degreeX: 3, degreeY: 15, orientation: 'bottomLeft', resultCoordinate: { x: 3, y: 3 } },
    { degreeX: 9, degreeY: 21, orientation: 'bottomLeft', resultCoordinate: { x: 4, y: 2 } },
    { degreeX: 3, degreeY: 21, orientation: 'bottomLeft', resultCoordinate: { x: 4, y: 3 } },
  ],
  3: [
    { degreeX: 15, degreeY: 1.5, orientation: 'bottomRight', resultCoordinate: { x: 0, y: 2 }, blindspot: true, repeat: controlRepeatTimes },
    { degreeX: 3, degreeY: 3, orientation: 'bottomRight', resultCoordinate: { x: 1, y: 0 } },
    { degreeX: 9, degreeY: 3, orientation: 'bottomRight', resultCoordinate: { x: 1, y: 1 } },
    { degreeX: 15, degreeY: 3, orientation: 'bottomRight', resultCoordinate: { x: 1, y: 2 } },
    { degreeX: 21, degreeY: 3, orientation: 'bottomRight', resultCoordinate: { x: 1, y: 3 } },
    { degreeX: 3, degreeY: 9, orientation: 'bottomRight', resultCoordinate: { x: 2, y: 0 } },
    { degreeX: 9, degreeY: 9, orientation: 'bottomRight', resultCoordinate: { x: 2, y: 1 } },
    { degreeX: 15, degreeY: 9, orientation: 'bottomRight', resultCoordinate: { x: 2, y: 2 } },
    { degreeX: 21, degreeY: 9, orientation: 'bottomRight', resultCoordinate: { x: 2, y: 3 } },
    { degreeX: 3, degreeY: 15, orientation: 'bottomRight', resultCoordinate: { x: 3, y: 0 } },
    { degreeX: 9, degreeY: 15, orientation: 'bottomRight', resultCoordinate: { x: 3, y: 1 } },
    { degreeX: 15, degreeY: 15, orientation: 'bottomRight', resultCoordinate: { x: 3, y: 2 } },
    { degreeX: 3, degreeY: 21, orientation: 'bottomRight', resultCoordinate: { x: 4, y: 0 } },
    { degreeX: 9, degreeY: 21, orientation: 'bottomRight', resultCoordinate: { x: 4, y: 1 } },
  ],
};
